import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscCategoryFilters = {
  contentGap: css`var(--csc-category-filters-content-gap, ${csSpacing.spacing05})`,
  showMoreDecorationLine: css`var(--csc-category-filters-show-more-text-decoration-line, underline)`,
}

export const style: CSSResult = css`
  cse-link {
    --cse-link-text-decoration-line: none;
  }

  cse-link.toggle {
    --cse-link-text-decoration-line: ${cscCategoryFilters.showMoreDecorationLine};
  }

  cse-expandable {
    --cse-expandable-list-row-gap: ${cscCategoryFilters.contentGap};
  }
`
